
import { type PiniaPluginContext } from 'pinia'

function MyPiniaPlugin({ store }: PiniaPluginContext) {
  store.$subscribe((mutation) => {
    // react to store changes
    console.log(`[🍍 ${mutation.storeId}]: ${mutation.type}.`)
  })

  // Note this has to be typed if you are using TS
  return { creationTime: new Date() }
}

export default defineNuxtPlugin((nuxt) => {
  nuxt.$pinia.use(MyPiniaPlugin)

  nuxt.$pinia.use(({ store }) => {
    store.router = markRaw(nuxt.$router)
  })
})